import React from 'react';
import HeroSlider from '../components/HeroSlider';
import CategoryGrid from '../components/CategoryGrid';
import ShapesCarousel from '../components/ShapesCarousel';
import ProductShowcase from '../components/ProductShowcase';
import Testimonials from '../components/Testimonials';
import PromiseMarquee from '../components/PromiseMarquee';
import InstagramFeed from '../components/InstagramFeed';
import BlogStrip from '../components/BlogStrip';
import { PressLogos, DualTiles, LabDiamondsBlock, FaqSection } from '../components/HomeSections';

const Home = () => {
  return (
    <main>
      <HeroSlider />
      {/* relative + z-10 so this section (and everything after it) scrolls
          over the sticky-pinned HeroSlider above. */}
      <section className="relative z-10 py-5 lg:py-8 bg-[#FFFFFF] text-center">
        <div className="max-w-3xl mx-auto px-6">
          <p className="font-serif text-[24px] text-[#1a1a1a] leading-relaxed">
            Real grown diamonds deserve a smarter setting. Welcome to Gold Vermeil.
          </p>
        </div>
      </section>
      <div className="relative z-10 bg-[#FFFFFF]">
        <CategoryGrid />
        <LabDiamondsBlock />
        {/* ShapesCarousel ("Discover your Shape") is a diamond solitaire-cut
            selector — only relevant for ring/solitaire products, which House of
            Seya no longer sells (studs, hoops, pendants, mangalsutra, bracelets
            don't use this shape-selection flow). Commented out, not deleted. */}
        {/* <ShapesCarousel /> */}
        <ProductShowcase />
        <PromiseMarquee />
        <DualTiles />
        {/* Testimonials ("Your love keeps us going") quotes reference engagement
            rings specifically (3 of 4 mock quotes). Commented out until we have
            testimonials for the current product lineup. */}
        {/* <Testimonials /> */}
        <InstagramFeed />
        {/* <BlogStrip linkable={true} /> */}
        {/* <PressLogos /> */}
        <FaqSection />
      </div>
    </main>
  );
};

export default Home;
